export const DOC_TYPES = {
  pdf: 'application/pdf',
  text: 'text/plain',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  heif: 'image/heif',
  hcif: 'image/hcif',
  svg: 'image/svg+xml',
  csv: 'text/csv',
  mp4: 'video/mp4',
  mov: 'video/mov',
  wmv: 'video/wmv',
  avi: 'video/avi',
};
